import {LocalPreferenceType} from '@toolify/client/src/stores/LocalPreferenceStore/enum/LocalPreferenceType'
import {useLocalPreferenceStore} from '@toolify/client/src/stores/LocalPreferenceStore/useLocalPreferenceStore'

type LocalPreferenceStore = ReturnType<typeof useLocalPreferenceStore>

// The last database the user opened in this workspace, kept apart from the general last visited
// resource. That one is overwritten by whatever they navigate to next - a dashboard, most of all -
// so by the time a page asks "which database was the user just working in?" it no longer knows.
// This one only ever moves when a database is opened, so the answer survives the pages that come
// after it.
export function saveLastVisitedDatabaseId(
  localPreferenceStore: LocalPreferenceStore,
  workspaceName: string,
  databaseId: string,
): Promise<void> {
  return localPreferenceStore.set(LocalPreferenceType.LastVisitedDatabaseId, databaseId, workspaceName)
}

export function getLastVisitedDatabaseId(
  localPreferenceStore: LocalPreferenceStore,
  workspaceName: string,
): string | null {
  if(!workspaceName) {
    return null
  }
  return localPreferenceStore.get(LocalPreferenceType.LastVisitedDatabaseId, workspaceName) ?? null
}
